import http from '../utils/http'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/request/"

// get请求
export async function getAntiResult(codedata) {
    return await http.get("query/20/" + codedata + "?location=", null)
}
// get请求(无数码验证码的查询接口)
export async function getAntiData(codedata,eno) {
    return await http.get("query-anti/20/" + codedata + "?eno="+eno+"&location=", null)
}
export async function ss_query(codedata, openId) {
    return await http.get("ss_query/20/" + codedata + "?openId=" + openId, null)
}
export async function getInfoByCode(codedata) {
    return await  http.get("getInfoByCode?code=" + codedata, null)
}
export async function ss_register(eno, openId, idCode, name, areaProvince, areaCity, tel, workUnit) {
    return await  http.get("user/ss_register?enterpriseNo=" + eno + "&openId=" + openId
        + "&idCode=" + idCode + "&name=" + name + "&areaProvince=" + areaProvince + "&areaCity=" + areaCity + "&tel=" + tel + "&workUnit=" + workUnit
        , null)
}
export async function ss_getUserByOpenId(eno, openId) {
    return await  http.get("user/ss_getUserByOpenId?enterpriseNo=" + eno + "&openId=" + openId, null)
}
export  async  function getUserOpenId(code) {
    return await http.get("wx/wxbc22565b3e7a59fd/getWxUserInfo?code=" + code, null)
}

export function getWechatAuth(outer_redirect_url,appid,scopeType){
    return http.get("wechat-sdk/to-user-auth-link?appid="+appid+"&scopeType="+scopeType+"&outer_redirect_url="+outer_redirect_url, null)
}

export function getTemplate(deptId){
    return http.get("marketing/v1/getTemplate?deptId=" + deptId, null)
}

export function getScoreConfig(deptId){
    return http.get("marketing/v1/getScoreConfig?deptId=" + deptId, null)
}

export function joinActivity(data){
    return http.post("marketing/v1/joinActivity", data)
}


export function getJoinDataByCode(data){
    return http.post("marketing/v1/getJoinDataByCode", data)
}

export function joinStoreActivity(data){
    return http.post("marketing/v1/joinStoreActivity", data)
}

export function registerByOpenId(enterpriseNo,authCode){
    return http.get("user/registerByOpenId?enterpriseNo="+enterpriseNo+"&authCode="+authCode, null)
}

export function getJSSDK(url,appid){
    return  http.get("wechat-sdk/v1/get-wechat-js-sdk?url="+url+"&appId="+appid)
}

export  function getStoreInfo(storeId,sign){
    return  http.get("marketing/v1/getStoreInfo?deptId="+storeId+"&sign="+sign)
}

export  function getAntiCountByAuthCode(eno,authCode){
    return  http.get("v1/getAntiCountByAuthCode?enterpriseNo="+eno+"&authCode="+authCode)
}


export  function updateUserInfo(data){
    return  http.post("user/update-user-info",data)
}
export  function queryAntiCheck(antiCode,checkCode,eno,authCode){
    return  http.get("query-check/" + antiCode + "?eno="+eno+"&checkCode="+checkCode+"&authCode="+authCode+"&location=", null)
}

export function joinCheckActivity(data){
    return http.post("marketing/v1/joinCheckActivity", data)
}


export function getTrace(code,eno){
    return http.get("trace/v1/get-jack-yun?code="+code+"&enterpriseNo="+eno)
}

export function getTraceByCode(code,eno){
    return http.get("trace/v1/get-trace?code="+code+"&enterpriseNo="+eno)
}

export function queryAnti(code,eno){
    return http.get("marketing/v1/anti?code="+code+"&eno="+eno)
}

export function getByProductId(productId,deptId){
    return http.get("process/getByProductId?productId="+productId+"&deptId="+deptId)
}



// WEBPACK FOOTER //
// ./src/api/api.js